export default __webpack_public_path__ + "static/media/delete.59e8d54d.svg";